<template>
  <v-card flat>
    <v-data-table
      :footer-props="{ 'items-per-page-options': [50, 100, 150, 200, -1] }"
      :headers="headers"
      :items="payload"
      :loading="loading"
      mobile-breakpoint="0"
    >
      <template v-slot:[`item.paymentDate`]="{ item }">
        <span v-if="item.paymentDate">
          {{ dateFormat(item.paymentDate) }}
        </span>
        <span v-else> -- </span>
      </template>
      <template v-slot:[`item.amount`]="{ item }">
        <span v-if="item.amount">
          {{ formatAmount(item.amount) }}
        </span>
        <span v-else> -- </span>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import moment from "moment";
export default {
  apollo: {
    getLandlordSubscriptionPayments() {
      return {
        query: require("@/landlord/api/queries/get_subscription_payments.graphql"),
        fetchPolicy: "no-cache",
        variables: () => ({
          landlordId: this.$route.params.id
        }),
        result({ data, loading }) {
          this.loading = loading;
          this.payload = data.getLandlordSubscriptionPayments;
        }
      };
    }
  },
  mounted() {
    this.$root.$on("fetchPayments", () => {
      this.$apollo.queries.getLandlordSubscriptionPayments.refetch();
    });
  },
  data() {
    return {
      loading: true,
      payload: [],
      headers: [
        { text: "Payment Date", value: "paymentDate" },
        { text: "Paid Amount", value: "amount" },
        { text: "Status", value: "status" }
      ]
    };
  },
  watch: {},
  methods: {
    formatAmount(amount) {
      if (amount) {
        return parseFloat(amount).toFixed(3);
      }
      return "";
    },
    dateFormat(date) {
      const rawDate = new Date(parseInt(date));
      return moment(rawDate, "YYYY-MM-DD").format("DD-MM-YYYY");
    }
  }
};
</script>

<style></style>
